export default __webpack_public_path__ + "static/media/Version (3) - Order of the Phoenix_01.ef7953aa.jpg";